// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"269":"ec04e8884eda925f","924":"cdf3dda4139e0e20"}[chunkId] + ".css";
};